// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"50a0c342","703":"fed1cc98"}[chunkId] + ".chunk.js";
};